import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IForgotPasswordPayload {
    data: {
        email: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IForgotPasswordState {
    status: string
    data: any
    errors: any
}

const initialState: IForgotPasswordState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const forgotPasswordSlice = createSlice({
    name: 'auth/forgot-password',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IForgotPasswordPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const forgotPasswordActions = forgotPasswordSlice.actions
export default forgotPasswordSlice.reducer
